import { OperatingSystemName } from 'functions/src/types/firestore/Game/System';

export const DOWNLOAD_DIALOG_PROPS = {
  'Undead Blocks': {
    title: 'Undead Blocks',
    version: '1.2.0',
    recRequirements: [
      {
        name: 'MAC' as OperatingSystemName,
        downloadUrl:
          'https://files.wagyu.io/undeadblocks/beta/UndeadBlocks_Launcher_Installer_1.0.2.dmg.zip',
        coverImageUrl: '/assets/images/test-thumbs/undead-blocks-mac-cover.png',
        requirements: {
          recommendedRequirements: {
            system: 'MacBook Pro 2020 (64-bit OS required)',
            processor: 'Core i5',
            memory: '16GB RAM',
            storage: 'At least 12GB of available storage',
            graphics: 'Mac M1 optimization still in progress*',
          },
          minimumRequirements: {
            system: 'MacBook Pro 2020 (64-bit OS required)',
            processor: 'Core i5',
            memory: '16GB RAM',
            storage: 'At least 12GB of available stroage',
            graphics: 'Mac M1 optimization still in progress*',
          },
        },
      },
      {
        name: 'WINDOWS' as OperatingSystemName,
        downloadUrl:
          'https://files.wagyu.io/undeadblocks/beta/UndeadBlocks_Launcher_Installer_1.0.2_1.exe',
        coverImageUrl:
          '/assets/images/test-thumbs/undead-blocks-windows-cover.png',
        requirements: {
          recommendedRequirements: {
            system: 'Windows 10 (64-bit OS required)',
            processor: 'Core i5 10400 card GTX 750 T1 or equivalent',
            memory: '16GB RAM',
            storage: 'At least 12GB of available stroage',
            graphics: '',
          },
          minimumRequirements: {
            system: 'Windows 10 (64-bit OS required)',
            processor: 'Core i5 10400 card GTX 750 T1 or equivalent',
            memory: '16GB RAM',
            storage: 'At least 12GB of available storage',
            graphics: '',
          },
        },
      },
    ],
  },
};
